import type { CSSProperties } from "react";
import { cn } from "@shared/lib/utils";

type SkeletonProps = {
  className?: string;
  style?: CSSProperties;
};

/** Loading placeholder block — size it with width/height utilities. */
export function Skeleton({ className, style }: SkeletonProps) {
  return (
    <div aria-hidden style={style} className={cn("animate-pulse rounded-md bg-white/8", className)} />
  );
}
